/** @internal */
export const __endShape = (ctx, attribs) => {
    let v;
    if ((v = attribs.fill) && v !== "none") {
        ctx.fill();
    }
    if ((v = attribs.stroke) && v !== "none") {
        ctx.stroke();
    }
    if ((v = attribs.clip)) {
        ctx.clip(v === true ? "nonzero" : v);
    }
};
